import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface AuditEntry {
  id: number;
  createdAt: string;
  actorUserId?: number;
  actorEmail?: string;
  actorName?: string;
  action: string;
  actionLabel: string;
  entityType?: string;
  entityId?: string;
  details?: string;
  ipAddress?: string;
}

export interface AuditPage {
  content: AuditEntry[];
  totalElements: number;
  totalPages: number;
  page: number;
  size: number;
}

/** Agency audit log (admins & managers — AUDIT_VIEW, enforced by the backend). */
@Injectable({ providedIn: 'root' })
export class AgencyAuditService {
  private base = `${environment.api.BASE_URL}/agencies/audit`;

  constructor(private http: HttpClient) {}

  search(page: number, size: number, action?: string | null): Observable<AuditPage> {
    let params = new HttpParams().set('page', page).set('size', size);
    if (action) {
      params = params.set('action', action);
    }
    return this.http.get<AuditPage>(this.base, { params });
  }

  actions(): Observable<{ value: string; label: string }[]> {
    return this.http.get<{ value: string; label: string }[]>(`${this.base}/actions`);
  }
}
